// Component to test contract interaction
import React, { useEffect } from "react";
import { useReadContract, useWriteContract } from "wagmi";
import { CONTRACT_ADDRESS, CONTRACT_ABI } from "../config/contractConfig"; // Import contract config
import DashboardLayout from '../components/DashboardLayout';
import { ethers } from "ethers";



const ContractTest: React.FC = () => {
    const [updateStatus, setUpdateStatus] = React.useState<string | null>(null); // Staust of the update
    const [isUpdating, setIsUpdating] = React.useState(false); // Loading state
    const [newFee, setNewFee] = React.useState(200); // Input for the new fee
  
    // Read the `defaultTokenFee` value
    const { data: defaultTokenFee, isLoading, isError } = useReadContract({
      address: CONTRACT_ADDRESS, // Contract address
      abi: CONTRACT_ABI, // ABI of the contract
      functionName: "serviceFee", // Name of the function you are calling
    });
  
    // Write to the contract (update defaultTokenFee)
    const { writeContract } = useWriteContract();
  
    const handleUpdateFee = async () => {
      setIsUpdating(true);
      setUpdateStatus(null); // Clear previous status
      try {
        const result = await writeContract({
          abi: CONTRACT_ABI,
          address: CONTRACT_ADDRESS,
          functionName: "UpdateServiceFee",
          args: [newFee], // Use the dynamic fee value
        });
        setUpdateStatus("Fee updated successfully!");
      } catch (error: any) {
        setUpdateStatus(`Error: ${error.message}`);
      } finally {
        setIsUpdating(false);
      }
    };
  
    return (
    <DashboardLayout>
      <div style={{ padding: "20px" }}>
        <h2>Smart Contract Test</h2>
  
        {/* Display defaultTokenFee */}
        {isLoading && <p>Loading defaultTokenFee...</p>}
        {isError && <p>Error fetching defaultTokenFee</p>}
        {defaultTokenFee !== undefined && defaultTokenFee !== null && (
          <p>
            Default Token Fee:{" "}
            {ethers.formatUnits(defaultTokenFee as bigint, 0)} {/* Safely cast */}
          </p>
        )}
  
        {/* Input for the new fee */}
        <div>
          <label htmlFor="newFee">New Fee: </label>
          <input
            id="newFee"
            type="number"
            value={newFee}
            onChange={(e) => setNewFee(Number(e.target.value))}
            style={{ marginRight: "10px" }}
          />
          <button onClick={handleUpdateFee} disabled={isUpdating}>
            {isUpdating ? "Updating Fee..." : "Update Default Token Fee"}
          </button>
        </div>
  
        {/* Update Status */}
        {updateStatus && <p>{updateStatus}</p>}
      </div>
    </DashboardLayout>
    );
  };

  export default ContractTest;

